import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { searchProducts } from "../services/api";
import ProductCard from "../components/ProductCard";
import { Search as SearchIcon, Loader2, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";

const useQuery = () => new URLSearchParams(useLocation().search);

const SearchPage = () => {
  const query = useQuery();
  const q = query.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [term, setTerm] = useState(q);
  const navigate = useNavigate();

  useEffect(() => {
    if (!q) { setResults([]); setLoading(false); return; }
    setLoading(true);
    searchProducts(q).then(setResults).catch(() => setResults([])).finally(() => setLoading(false));
  }, [q]);

  const submit = (e) => {
    e.preventDefault();
    if (term.trim()) navigate(`/search?q=${encodeURIComponent(term.trim())}`);
  };

  return (
    <div>
      <section className="bg-ink-gradient py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <span className="text-[#E7C766] font-bold text-sm uppercase tracking-widest">Search</span>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl text-white mt-3 mb-6">Find Your Product</h1>
          <form onSubmit={submit} className="relative max-w-xl mx-auto">
            <SearchIcon className="w-5 h-5 text-neutral-400 absolute left-4 top-1/2 -translate-y-1/2" />
            <input value={term} onChange={(e) => setTerm(e.target.value)} placeholder="Search medals, teamwear, pins..."
              className="w-full h-13 pl-12 pr-4 py-3.5 rounded-full text-neutral-800 focus:outline-none" />
          </form>
        </div>
      </section>

      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          {loading ? (
            <div className="py-24 flex justify-center"><Loader2 className="w-8 h-8 text-[#C9A227] animate-spin" /></div>
          ) : (
            <>
              <p className="text-neutral-600 mb-8">
                {q ? <>Showing <span className="font-semibold text-[#14171c]">{results.length}</span> result{results.length !== 1 ? "s" : ""} for “<span className="font-semibold text-[#14171c]">{q}</span>”</> : "Type a search term above."}
              </p>
              {results.length > 0 ? (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
                  {results.map((p) => (<ProductCard key={p.id} product={p} />))}
                </div>
              ) : q ? (
                <div className="text-center py-16">
                  <SearchIcon className="w-12 h-12 text-neutral-300 mx-auto mb-4" />
                  <h2 className="font-display font-bold text-xl text-[#14171c]">No products found</h2>
                  <p className="text-neutral-500 mt-2">Try a different keyword, or request a custom quote.</p>
                  <Link to="/contact"><Button className="mt-6 bg-[#C9A227] hover:bg-[#A6841B] text-white rounded-full h-12 px-7">Request a Custom Quote <ArrowRight className="w-4 h-4 ml-1" /></Button></Link>
                </div>
              ) : null}
            </>
          )}
        </div>
      </section>
    </div>
  );
};

export default SearchPage;
